module.exports = __webpack_public_path__ + "img/37.1.72e0cdf5.jpg";